// extracted by mini-css-extract-plugin
export default {"melodyVideo":"LP-z","isFullWidth":"MP-z","landingPageVideo":"NP-z","play":"OP-z","iframeVideo":"PP-z","playHidden":"QP-z","fullwidth":"RP-z"};